export default [
  {
    id: 'step1',
    title: '働き方',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'step2',
    title: '希望条件',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'confirm',
    title: '確認',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'complete',
    title: '完了',
    previewJumpId: 'close-preview-button-above'
  }
]
